import React from 'react';
import { Tabs } from 'antd';
import ReactJson from '@microlink/react-json-view';
import { usePresence } from '../Common/motion';

/**
 * What one application opens onto, in the full width of the grid.
 *
 * A tab strip over a single tab, because metadata is the first of these rather
 * than the only one there will ever be — a declaration and the items it covers
 * belong here too, and each is a tab rather than another thing stacked on the
 * one below it.
 *
 * It owns whether it is on screen rather than the card above it, because this
 * section is itself the full-width grid item: wrapped in anything, it would
 * stop spanning the grid. So it takes `open` and holds itself there while it
 * animates out. Its contents are still only rendered while it is open.
 */
const ApplicationDetail = ({ record, open }: { record: any; open: boolean }) => {
    const { mounted, motionProps } = usePresence(open);

    const metadata = record.metadata;
    const isEmpty = !metadata || (typeof metadata === 'object' && Object.keys(metadata).length === 0);

    if (!mounted) return null;

    return (
        <section
            className="app-detail nx-collapse"
            {...motionProps}
            aria-label={`${record.name} details`}
        >
            <Tabs
                className="app-detail__tabs"
                items={[
                    {
                        key: 'metadata',
                        label: 'Metadata',
                        children: isEmpty ? (
                            <div className="app-detail__empty">
                                No metadata was declared for this application.
                            </div>
                        ) : (
                            <div className="app-detail__json">
                                <ReactJson
                                    style={{ padding: '14px', background: 'transparent' }}
                                    src={metadata}
                                    displayDataTypes={false}
                                    name={null}
                                    displayArrayKey={false}
                                    displayObjectSize={false}
                                />
                            </div>
                        ),
                    },
                ]}
            />
        </section>
    );
};

export default ApplicationDetail;
